import React from "react";
import { Skeleton } from "components";
import { Col, Row } from "react-bootstrap";

export default function BookDetailsSkeleton() {
  return (
    <Row>
      <Col xl={4} lg={5} md={5} sm={12} xs={12}>
        <Skeleton count={1} height={400} width={"100%"} />
      </Col>
      <Col xl={5} lg={7} md={7} sm={12} xs={12} className="p-3 p-lg-5">
        <Skeleton count={1} height={10} width={"40%"} />
        <Skeleton count={1} height={10} width={"40%"} className="mt-4 mt-4 mt-4 " />
        <Skeleton count={1} height={10} width={"80%"} className="mt-2" />
        <Skeleton count={1} height={10} width={"100%"} className="mt-4" />
        <Skeleton count={1} height={10} width={"100%"} className="mt-4 mt-4 mt-4 " />
        <Skeleton count={1} height={10} width={"100%"} />
        <Skeleton count={1} height={10} width={"100%"} />
        <Skeleton count={1} height={10} width={"100%"} />
      </Col>
      <Col xl={3} lg={12} md={12} sm={12} xs={12} className="mt-4 mt-xl-5">
        <Skeleton count={1} height={300} width={"100%"} />
      </Col>
    </Row>
  );
}
